// extracted by mini-css-extract-plugin
export default {"button":"ButtonStyles_button__LORbv","yellow":"ButtonStyles_yellow__Qh5tt","purple":"ButtonStyles_purple__q2ZaK"};